import { useRef, useEffect, useState } from "react";
import {
  useComputedColorScheme,
  Loader,
  Card,
  Code,
  Text,
  Title,
  Center,
  Container,
  Button,
  Paper,
  Stack,
  Group,
  Badge,
  NumberFormatter,
  rem,
} from "@mantine/core";
import { useStore } from "../store";
import {
  deleteAllGalleryImages,
  getMyProfile,
  customerPortal,
  deleteUserAccount,
} from "../api.js";
import { IconCoins, IconPhotoBolt } from "@tabler/icons-react";
import PlanBadge from "./PlanBadge.jsx";
import { Link } from "wouter";

export default function ProfilePage() {
  const profile = useStore((state) => state.profile);
  const setProfile = useStore((state) => state.setProfile);
  const setAuthToken = useStore((state) => state.setAuthToken);

  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoadingPortal, setIsLoadingPortal] = useState(false);
  const initialized = useRef(false);

  var theme = useComputedColorScheme();

  const confirmDelete = () => {
    if (
      confirm(
        "Are you sure you want to delete all images from your gallery? This can't be undone. Please also note that this can take quite a while."
      )
    ) {
      setIsDeleting(true);
      deleteAllGalleryImages()
        .then(() => setIsDeleting(false))
        .catch((error) => {
          alert(
            "Something went wrong while deleting, please try again. Details: " +
              error
          );
        });
    }
  };

  const confirmDeleteAccount = () => {
    if (
      confirm(
        "Are you sure you want to delete your account? This can't be undone. Please also note that this can take quite a while. IF YOU HAVE CREDITS IN YOUR ACCOUNT, THOSE WILL BE LOST!"
      )
    ) {
      setIsDeleting(true);
      deleteUserAccount()
        .then(() => {
          setIsDeleting(false);
          setAuthToken(null);
          setProfile(null);
          window.location.href = "www.photovortex.com";
        })
        .catch((error) => {
          alert(
            "Something went wrong while deleting, please try again. Details: " +
              error
          );
        });
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getMyProfile().then((data) => {
        setProfile(data);
      });
    }
  }, []);

  if (!profile)
    return (
      <Container>
        <Center>
          <Loader />
        </Center>
      </Container>
    );

  const iconCoin = <IconCoins style={{ width: rem(18), height: rem(18) }} />;
  const iconBolt = (
    <IconPhotoBolt style={{ width: rem(18), height: rem(18) }} />
  );

  return (
    <Container size="xs">
      <Title>Profile</Title>

      <Paper
        radius="md"
        p="md"
        bg={theme == "dark" ? "dark" : "dark.0"}
        my="lg"
      >
        {profile.preview ? "Preview Features enabled" : null}
        <Stack>
          <Text fz="lg" fw={500}>
            Credits
          </Text>
          <Group justify="space-between">
            <Badge
              color="white"
              radius="xs"
              size="lg"
              variant="light"
              leftSection={iconCoin}
            >
              <NumberFormatter
                value={profile.credits}
                decimalScale={0}
                thousandSeparator
              />
            </Badge>

            {/* <Button
              variant="light"
              onClick={() => {
                checkout({})
                  .then((data) => {
                    location.href = data.redirectUrl;
                  })
                  .catch((error) => {
                    alert("Oh no, something went wrong: " + error);
                  });
              }}
            >
              Buy credits
            </Button> */}
          </Group>
          <Text mt="xl" fz="lg" fw={500}>
            Model Training Credits
          </Text>
          <Group justify="space-between">
            <Badge
              color="white"
              radius="xs"
              size="lg"
              variant="light"
              leftSection={iconBolt}
            >
              <NumberFormatter
                value={profile.trainingCredits}
                decimalScale={0}
                thousandSeparator
              />
            </Badge>
          </Group>
          <Group justify="flex-end">
            <Button variant="light" component={Link} to="/payment/prepaid">
              Buy Credits
            </Button>
          </Group>
        </Stack>
      </Paper>
      <Paper
        radius="md"
        p="md"
        bg={theme == "dark" ? "dark" : "dark.0"}
        my="lg"
      >
        <Stack>
          <Text mb="sm" mt="xl" fz="lg" fw={500}>
            Subscription
          </Text>
          <Group justify="space-between">
            <PlanBadge plan={profile.plan} size="lg" />
            {profile.plan !== "Free" ? (
              <Button
                variant="light"
                loading={isLoadingPortal}
                onClick={() => {
                  setIsLoadingPortal(true);
                  customerPortal().then((data) => {
                    window.location = data.redirectUrl;
                    setIsLoadingPortal(false);
                  });
                }}
              >
                Manage subscription
              </Button>
            ) : (
              <Button component={Link} variant="light" href="/payment/plans">
                Upgrade
              </Button>
            )}
          </Group>
        </Stack>
      </Paper>

      <Paper
        radius="md"
        p="lg"
        bg={theme == "dark" ? "dark" : "dark.0"}
        my="lg"
      >
        <Group>
          <Text c="dimmed">You are logged in as</Text>{" "}
          <Code>{profile.loginName}</Code>
        </Group>
      </Paper>

      <Card withBorder mt="8rem">
        <Text size="lg" mb="lg">
          Danger Zone
        </Text>
        <Group>
          <Button
            color="red"
            loading={isDeleting}
            onClick={() => confirmDelete()}
          >
            Delete all images
          </Button>

          <Button
            color="red"
            loading={isDeleting}
            onClick={() => confirmDeleteAccount()}
          >
            Delete account completely
          </Button>
        </Group>
      </Card>
    </Container>
  );
}
